import { createContext, useEffect, useReducer } from "react";
import PropTypes from "prop-types";
import { API_ENDPOINTS } from "src/api/apiEndPoints";
import { eduleyApi } from "src/api/apiConfig";
import { useAuth0 } from "@auth0/auth0-react";

// ----------------------------------------------------------------------

let auth0Client = null;

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  token: "",
  loading: false,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return { ...state, isAuthenticated, isInitialized: true, user };
  },
  FETCHUSERDATA: (state, action) => {
    const { loading } = action.payload;
    return { ...state, loading: loading };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;
    console.log("action login", user);
    return { ...state, isAuthenticated: true, user };
  },
  SETPROFILE: (state, action) => {
    const user = action.payload;
    console.log("action login", user);
    return {
      ...state,
      isAuthenticated: true,
      user: { ...state.user, profile: user },
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  SETTOKEN: (state, action) => ({
    ...state,
    token: action.payload,
  }),
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  method: "auth0",
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  // const navigate=useNavigate()
  const {
    isLoading,
    isAuthenticated,
    error,
    user,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
    loginWithPopup,
  } = useAuth0();

  useEffect(() => {
    initialize();
  }, [isLoading]);
  const initialize = async () => {
    dispatch({
      type: "FETCHUSERDATA",
      payload: { loading: isLoading },
    });
    try {
      console.log("initialize", isAuthenticated);
      if (isAuthenticated) {
        await getAccessTokenSilentlybyauth();
        dispatch({
          type: "INITIALIZE",
          payload: { isAuthenticated, user },
        });
      } else {
        dispatch({
          type: "INITIALIZE",
          payload: { isAuthenticated, user: null },
        });
      }
    } catch (err) {
      console.error(err);
      dispatch({
        type: "INITIALIZE",
        payload: { isAuthenticated: false, user: null },
      });
    }
  };

  const getUser = async () => {
    dispatch({
      type: "INITIALIZE",
      payload: { isAuthenticated: true, user },
    });
  };
  const loginbyauth = async () => {
    loginWithRedirect({
        appState: {
            returnTo: window.location.origin+window.location.pathname
        }
    });
    // await loginWithPopup();
    // await getAccessTokenWithPopup()
  };

  const authintication=async()=>{
    if (isAuthenticated) {
      await getAccessTokenSilentlybyauth();
      getStudentProfile();
      dispatch({ type: "LOGIN", payload: { user } });
    }
  }

  const getStudentProfile = async () => {
    try {
      let res = await eduleyApi.get(API_ENDPOINTS.STUDENT);
      console.log(res);
      dispatch({ type: "SETPROFILE", payload: res.data[0] });
      // navigate('/onboard-register')
    } catch (error) {
      if (error?.data?.status == 401 || error?.data?.status == 403) {
        logoutbyauth();
       }
    }
  };

  const logoutbyauth = async () => {
    localStorage.clear();
    await logout({
      returnTo: window.location.origin
    });
    document.cookie = `isLoggedIn=;domain=${process.env.REACT_APP_DOMAIN_NAME};path=/`;
    let user = {};
    dispatch({ type: "LOGIN", payload: { user } });
    dispatch({ type: "LOGOUT" });
    // window.location.href = '/';
  };

  const getAccessTokenSilentlybyauth = async () => {
    try {
      let token = await getAccessTokenSilently();
      // let token = await getAccessTokenWithPopup()
      document.cookie = `isLoggedIn=true;domain=${process.env.REACT_APP_DOMAIN_NAME};path=/`;

      await localStorage.setItem("accessToken", token);
      // console.log(token)
      dispatch({ type: "SETTOKEN", payload: token });
          } catch (error) {}
  };
  const loginWithRedirectbyauth = async () => {
    try {
      let token = await loginWithRedirect();
    } catch (error) {}
  };
  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "auth0",
        user: {
          ...state.user,
          id: state?.user?.sub,
          photoURL: state?.user?.picture,
          email: state?.user?.email,
          displayName: "",
          role: "",
        },
        getUser,
        login: loginbyauth,
        logout: logoutbyauth,
        getAccessTokenSilently: getAccessTokenSilentlybyauth,
        loginWithRedirect: loginWithRedirectbyauth,
        getStudentProfile,
        isLoading,
        authintication,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
